import { uploadMedia } from './uploadMedia';
import { marketing } from './marketing';
import { users } from './users';
import { author } from './author';
import { banner } from './banner';
import { linkChecker } from './linkChecker';
import { vtb } from './vtb';
import { specialAccess } from './specialAccess';
import { qualitySystem } from './qualitySystem';
import { lms } from './lms';
import { sync } from './sync';
import { course } from './course';
import { courseResult } from './courseResult';

export const navConfig = {
  redactie: [users, author, uploadMedia, linkChecker, specialAccess, marketing, qualitySystem, course],
  marketing: [marketing, banner, qualitySystem, course],
  sales: [users, sync, marketing, vtb, specialAccess, qualitySystem, lms, courseResult],
  administrator: [
    users,
    sync,
    author,
    uploadMedia,
    linkChecker,
    marketing,
    banner,
    vtb,
    specialAccess,
    qualitySystem,
    lms,
    course,
    courseResult
  ]
};
